module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-2500-Classes-Inactive-c2c581a2cfc170125096ed4d6038f533.png";